import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiHelperService } from '../../core/ui-helper/ui-helper.service';
import { DropdownOption } from '../../shared/models/dropdown-option.model';
import { SharedConfig } from '../../shared/models/shared-config.model';
import { sharedConfig } from '../../shared/shared.config';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.css']
})
export class LanguageDropdownComponent implements OnInit, OnDestroy {
  languageList: DropdownOption[] = [];
  selectedLanguage: DropdownOption;
  isOpen = false;
  subscriptions = new Subscription();

  constructor(@Inject(sharedConfig) private config: SharedConfig,
    private uiHelperService: UiHelperService) {
    this.initData();
  }

  ngOnInit() {
    this.subscribeForLangChange();
  }

  /**
   * @description to subscribe for language change
   * @memberof LanguageDropdownComponent
   */
  subscribeForLangChange() {
    this.subscriptions.add(
      this.uiHelperService.selectedLang$.subscribe(
        (lang) => {
          this.setSelectedLanguage(lang);
        }
      )
    );
  }

  /**
   * @method onLanguageChange
   * @description this method used when language changed
   * @return void
   * @param DropdownOption change
   */
   public onLanguageChange(change: DropdownOption) {
    this.setSelectedLanguage(change.code);
    this.uiHelperService.useLanguage(change.code);
    this.togglePopup();
  }

  /**
   * @name toggleLanguage
   * @description this method is used to toggle language for mobile view
   * @param index
   * @memberof LanguageDropdownComponent
   */
  toggleLanguage(index: number) {
    let nextIndex = index + 1;
    if (nextIndex >= this.languageList.length) {
      nextIndex = 0;
    }
    this.onLanguageChange(this.languageList[nextIndex]);
  }

  /**
   *
   *
   * @description to set the selected language
   * @param code
   * @memberof LanguageDropdownComponent
   */
  setSelectedLanguage(code: string) {
    this.languageList.forEach(lang => {
      lang.selected = code === lang.code;
      if (lang.selected) {
        this.selectedLanguage = lang;
      }
    });
  }

  /**
   * @method togglePopup
   * @description this method used to toggle language popup
   * @return void
   */
  public togglePopup() {
    this.isOpen = !this.isOpen;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * @method togglePopup
   * @description this method used to load language data
   * @return void
   */
  private initData() {
    this.languageList = JSON.parse(JSON.stringify(this.config.availableLanguages));
    this.selectedLanguage = this.uiHelperService.selectedLanguage
      ? this.languageList.find(lang => lang.code.toLowerCase() === this.uiHelperService.selectedLanguage.toLowerCase())
      : this.languageList[0];
    this.selectedLanguage.selected = true;
  }

}
